import React from 'react'
import styled from 'styled-components'
import getThemeValue from '../../utils/getThemeValue'
import { useTranslation } from 'react-i18next'

const StyledLoginBoxHeadline = styled.h1`
  font-size: 1em;
  //   font-weight: 600;
  text-align: center;
  color: white;

  @media screen and (min-width: 425px) {
    font-size: 1.8rem;
  }
  @media screen and (min-width: 576px) {
    font-size: 2.5rem;
  }
`

const StyledLoginBoxText = styled.h5`
  margin-top: 3rem;
  margin-bottom: 1.25rem;
  text-align: center;
  color: white;
  font-weight: 400;
`

const StyledButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`

const StyledLinkButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0.55rem 1.2rem;
  border-radius: 0.375rem;

  font-weight: 600;
  text-decoration: none;

  background: ${(props) => props.theme.primaryColor || '#0d6efd'};
  color: white;

  &:hover {
    filter: brightness(1.05);
    color: white;
    text-decoration: none;
  }

  &:active {
    transform: translateY(1px);
  }
`

const IamLoginBanner = ({ iamLoginUrl }) => {
  const { t } = useTranslation()
  if (!iamLoginUrl) return null

  return (
    <div className='styledBox smallBox iam-login-box'>
      <StyledLoginBoxHeadline>
        {getThemeValue('userLogin', 'loginBoxHeadline', '')}
      </StyledLoginBoxHeadline>

      <StyledLoginBoxText>{t('loginBox:securitasLogin')}</StyledLoginBoxText>

      <hr />

      <StyledButtonWrap>
        <StyledLinkButton href={iamLoginUrl} rel='noreferrer'>
          IAM Pub
        </StyledLinkButton>
      </StyledButtonWrap>
    </div>
  )
}

export default IamLoginBanner
